// @flow
import { PlusOutlined } from '@ant-design/icons';
import React from 'react';
import { navigate } from '@reach/router';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';

import { Section } from '../../../../components/layout';
import { Icon } from '../../../../components/ui';
import type { Vehicle } from '../../../../lib/types';
import Grid, { GridItem } from '../../../../components/layout/Grid';
import Field from '../../../../components/card/Field';
import { formatDate } from '../../lib';
import { insuranceClasses } from '../../../../lib/enum';
import SectionTitle from '../SectionTitle';
import { Element } from 'react-scroll/modules';
import OsagoList from '../../containers/OsagoList';
import KaskoList from '../../containers/KaskoList';
import {
  applyMaskToValue,
  convertContractorToString
} from '../../../../lib/helpers';
import { formatOsagoMask } from '../../../../components/inputs/masked-inputs/OsagoInput';

type Props = {
  vehicle: Vehicle,
  editable: boolean,
  canHandleMaintenanceServices: boolean
};

const StyledIcon = styled(Icon)`
  cursor: pointer;
`;
const SectionContent = styled.div`
  padding: 16px;
`;
const StyledAntIcon = styled(PlusOutlined)`
  cursor: pointer;
  color: #2b7cff;
`;

export default class InsuranceTab extends React.Component<Props> {
  onEditOsago = () => {
    const { id: vehicleId, osago } = this.props.vehicle;
    navigate(`/vehicles/${vehicleId}/osagos/${osago.id || ''}`, {
      replace: true
    });
  };

  render() {
    const { vehicle, editable, canHandleMaintenanceServices } = this.props;

    const { osago, kasko } = vehicle;

    return (
      <>
        {!isEmpty(osago) ? (
          <Section>
            <SectionTitle
              divider
              suffix={
                editable && (
                  <StyledIcon
                    onClick={this.onEditOsago}
                    type="edit"
                    size={16}
                  />
                )
              }
            >
              ОСАГО
            </SectionTitle>
            <SectionContent>
              <Grid gutter="16px">
                <GridItem>
                  <Field label="Номер полиса ОСАГО">
                    {applyMaskToValue(osago.osagoNumber, formatOsagoMask)}
                  </Field>
                </GridItem>
                <GridItem>
                  <Field label="Наименование страховщика">
                    {convertContractorToString(osago.contractor)}
                  </Field>
                </GridItem>
                <GridItem>
                  <Field label="Класс на начало годового срока страхования">
                    {osago.insuranceClass &&
                      insuranceClasses[osago.insuranceClass]}
                  </Field>
                </GridItem>
                <GridItem>
                  <Field label="Дата начала действия полиса">
                    {formatDate(osago.osagoStartedDate)}
                  </Field>
                </GridItem>
                <GridItem>
                  <Field label="Дата окончания действия полиса">
                    {formatDate(osago.osagoFinishedDate)}
                  </Field>
                </GridItem>

                {osago.diagnosticCardNumber && (
                  <GridItem>
                    <Field label="Диагностическая карта">
                      {osago.diagnosticCardNumber}
                    </Field>
                  </GridItem>
                )}
                <GridItem>
                  <Field label="Кол-во страховых случаев, по которым выплачена страховка">
                    {osago.insuranceCasesCount}
                  </Field>
                </GridItem>
                <GridItem>
                  <Field label="Сумма оплаты">
                    {(osago.paymentAmount || 0) + ' руб.'}
                  </Field>
                </GridItem>
              </Grid>
            </SectionContent>
          </Section>
        ) : null}
        {!isEmpty(kasko) && (
          <Section>
            <SectionTitle divider>КАСКО</SectionTitle>
            <SectionContent>
              <Grid gutter="16px">
                <GridItem>
                  <Field label="Номер полиса КАСКО">
                    {kasko.kaskoNumber || '-'}
                  </Field>
                </GridItem>
                <GridItem>
                  <Field label="Дата начала действия">
                    {formatDate(kasko.startDate)}
                  </Field>
                </GridItem>
                <GridItem>
                  <Field label="Дата окончания действия">
                    {formatDate(kasko.endDate)}
                  </Field>
                </GridItem>
                <GridItem>
                  <Field label="Наименование страховщика">
                    {convertContractorToString(kasko.contractor)}
                  </Field>
                </GridItem>
              </Grid>
            </SectionContent>
          </Section>
        )}
        <Element name="osago">
          <Section>
            <SectionTitle
              divider
              suffix={
                editable &&
                canHandleMaintenanceServices && (
                  <StyledAntIcon
                    onClick={() =>
                      navigate(`/vehicles/${vehicle.id}/osagos/new`)
                    }
                    size={16}
                  />
                )
              }
            >
              Архив полисов ОСАГО
            </SectionTitle>
            <OsagoList
              vehicleId={vehicle.id}
              enableDelete={editable && canHandleMaintenanceServices}
            />
          </Section>
        </Element>
        <Element name="kasko">
          <Section>
            <SectionTitle
              divider
              suffix={
                editable &&
                canHandleMaintenanceServices && (
                  <StyledAntIcon
                    onClick={() =>
                      navigate(`/vehicles/${vehicle.id}/kasko/new`)
                    }
                    size={16}
                  />
                )
              }
            >
              Архив полисов КАСКО
            </SectionTitle>
            <KaskoList
              vehicleId={vehicle.id}
              enableDelete={editable && canHandleMaintenanceServices}
            />
          </Section>
        </Element>
      </>
    );
  }
}
